module.exports = {
    global: require("./global.json"),
    main: require("./main.json"),
    home: require("./home.json"),
    domainsetting: require("./domainsetting.json"),
    rcmtable: require("./rcmtable.json"),
    cacherules: require("./cacherules.json"),
    wafrules: require("./wafrules.json"),
    certsmanage: require("./certsmanage.json"),
    wafevent: require("./wafevent.json"),
    groupresource: require("./groupresource.json"),
    servicegroup: require("./servicegroup.json"),
    slbsetting: require("./slbsetting.json"),
    edgesetting: require("./edgesetting.json"),
    ninjasetting: require("./ninjasetting.json"),
    probesetting: require("./probesetting.json"),
    dashboard: require("./dashboard.json"),
    routesMenu: require("./routesMenu.json"),
    usersmanage: require("./usersmanage.json"),
    rolesmanage: require("./rolesmanage.json"),
    userInfo: require("./userInfo.json"),
    support: require("./support.json"),
    subscription: require("./subscription.json"),
    tasks: require("./tasks.json"),
    systemLog: require("./systemLog.json"),
    cacheClear: require("./cacheclear.json"),
    alertrules: require("./alertrules.json"),
    notificationChannels: require("./notificationChannels.json"),
    appProfileSetting: require("./appProfileSetting.json"),
    originPolicy: require("./originPolicy.json"),
    htmlPage: require("./htmlPage.json"),
    scrolls: require("./scrolls.json"),
    owasp: require("./owasp.json"),
    recordLineGroups: require("./recordLineGroups.json"),
    resourceType: require("./resourceType.json"),
    objectExplanation: require("./objectExplanation.json"),
    nodeRegisteration: require("./nodeRegisteration.json"),
    payment: require("./payment.json"),
    groupPattern: require("./groupPattern.json"),
    apiKeys: require("./apiKeys.json"),
    accountInfo: require("./accountInfo.json"),
    backends: require("./backends.json"),
    backendsTitle: require("./backendsTitle.json"),
    certsApply: require("./certsapply.json"),
    ipDomainCerts: require("./ipDomainCerts.json"),
    security: require("./security.json"),
    netflowAnalyze: require("./netflowAnalyze.json"),
    frontends: require("./frontends.json"),
    intelligent: require("./intelligent.json"),
    behaviorAnalyze: require("./behaviorAnalyze.json"),
    intelligentProtectionSettings: require("./intelligentProtectionSettings.json"),
};



// WEBPACK FOOTER //
// ./src/i18n/zh-CN/index.js